module.exports = __webpack_public_path__ + "src/img/splash_3.a5030c99.png";